/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Material Dashboard 2 React base styles
import borders from "assets/theme-dark/base/borders";

// Material Dashboard 2 React helper functions
import pxToRem from "assets/theme-dark/functions/pxToRem";

const { borderRadius } = borders;
// Subtle slate track that reads on the navy surfaces.
const TRACK = "rgba(148, 163, 184, 0.18)";

const linearProgress = {
  styleOverrides: {
    root: {
      height: pxToRem(6),
      borderRadius: borderRadius.md,
      overflow: "hidden",
      position: "relative",
    },

    colorPrimary: {
      backgroundColor: TRACK,
    },

    colorSecondary: {
      backgroundColor: TRACK,
    },

    bar: {
      height: pxToRem(6),
      borderRadius: borderRadius.sm,
      position: "absolute",
      // Keep MUI's native transform-based determinate behavior.
      // Forcing translate(0,0) makes all bars look fully filled.
    },
  },
};

export default linearProgress;
